import { useAuth } from "../lib/auth";

const API_BASE = import.meta.env.VITE_API_URL ?? "";

export default function PendingApproval() {
  const { refetch } = useAuth();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white px-6 py-10 sm:p-10 rounded-2xl shadow-sm border border-gray-200 flex flex-col items-center gap-4 w-full max-w-sm text-center">
        <div className="w-12 h-12 bg-yellow-100 rounded-xl flex items-center justify-center">
          <span className="text-yellow-600 text-2xl" aria-hidden="true">
            ⏳
          </span>
        </div>
        <h1 className="text-xl font-bold text-gray-900">Ci siamo quasi</h1>
        <p className="text-gray-500 text-sm">
          La registrazione è andata a buon fine. Riceverai una mail di conferma quando un amministratore attiverà il tuo
          account: segui il link nella mail per accedere.
        </p>
        <button type="button" onClick={() => refetch()} className="text-sm text-blue-600 hover:underline">
          Controlla subito
        </button>
        <div className="w-full border-t border-gray-100 pt-4 flex flex-col items-center gap-2">
          <p className="text-xs text-gray-400">Hai sbagliato account?</p>
          <a
            href={`${API_BASE}/api/auth/logout`}
            onClick={() => localStorage.removeItem("auth_token")}
            className="text-sm font-medium text-gray-600 hover:text-gray-900 underline"
          >
            Accedi con un account diverso
          </a>
        </div>
      </div>
    </div>
  );
}
